import palette from "theme/palette";

export default theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  logoWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '63px',
    flexShrink: 0
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px',
    justifyContent: 'space-between',
  },
  logoLink: {
    //fontSize: 0,
  },
  logoImage: {
    cursor: 'pointer',
    width: '120px',
    //height: '60px'
  },
  logoDivider: {
    marginBottom:theme.spacing(0)
  },
  profile: {
    height: '100px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'left',
    backgroundImage: 'url(/images/connected_world.svg)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  },
  avatar: {
    width: '100px',
    height: '100px'
  },
  nameText: {
    marginTop: theme.spacing(2)
  },
  bioText: {},
  profileDivider: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(0)
  },
  listSubheader: {
    color: theme.palette.text.secondary
  },
  listItem: {
    cursor: 'pointer',
    transition: "background-color 0.2s ease, color 0.2s ease",
    "&:hover, &.MuiListItem-root:hover, &.MuiListItemButton-root:hover": {
      borderLeft: `4px solid ${theme.palette.primary.main}`,
      borderRadius: "6px",
      backgroundColor: `${palette.latestLightGreen.main} !important`,
      "& $listItemText, & .MuiListItemText-primary": {
        color: `${theme.palette.primary.main} !important`,
        fontWeight: "600 !important",
      },
      "& $listItemIcon, & .MuiListItemIcon-root": {
        color: `${theme.palette.primary.main} !important`,
      },
    },
    "&.Mui-selected, &.Mui-selected:hover, &.MuiListItem-root.Mui-selected, &.MuiListItem-root.Mui-selected:hover": {
      borderLeft: `4px solid ${theme.palette.primary.main}`,
      borderRadius: "6px",
      backgroundColor: `${palette.latestLightGreen.main} !important`,
      "& $listItemText, & .MuiListItemText-primary": {
        color: `${theme.palette.primary.main} !important`,
        fontWeight: "600 !important",
      },
      "& $listItemIcon, & .MuiListItemIcon-root": {
        color: `${theme.palette.primary.main} !important`,
      },
    },
    '& + &': {
      marginTop: theme.spacing(1)
    }
  },
  activeListItem: {
    borderLeft: `4px solid ${theme.palette.primary.main} !important`,
    borderRadius: "6px !important",
    backgroundColor: `${palette.latestLightGreen.main} !important`,
    "&:hover": {
      backgroundColor: `${palette.latestLightGreen.main} !important`,
    },
    "& $listItemText, & .MuiListItemText-primary": {
      color: `${theme.palette.primary.main} !important`,
      fontWeight: "600 !important",
    },
    "& $listItemIcon, & .MuiListItemIcon-root": {
      color: `${theme.palette.primary.main} !important`,
    },
  },
  listItemIcon: {
    marginRight: 0
  },
  listItemText: {
    fontWeight: 500,
    fontSize: '16px',
    color: theme.palette.text.secondary
  },
  listDivider: {
    marginBottom:theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  title: {
    color: theme.palette.common.primary
  }
});
